import { render } from "./bottomTab.vue?vue&type=template&id=481d299d&scoped=true"
import script from "./bottomTab.vue?vue&type=script&lang=js"
export * from "./bottomTab.vue?vue&type=script&lang=js"

import "./bottomTab.vue?vue&type=style&index=0&id=481d299d&scoped=true&lang=css"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-481d299d"]])

export default __exports__